<ng-container *ngIf="canRevert">
  <button type="button" class="btn btn-info me-2" (click)="revertChanges()" [disabled]="!canRevert">Revert ALL Changes
  </button>
</ng-container>
